module.exports = __webpack_public_path__ + "static/img/QLD-22.4e6b9f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-22.jpg
// module id = M3x9
// module chunks = 0